import { useState } from 'react';
export const useGalleryContext = () => {
    const [currentId, setCurrentId] = useState('');
    const [galleryData, setGalleryData] = useState({
        imagesList: [],
        lightboxImagesList: [],
        lightboxThumbnails: [],
        thumbnailsList: [],
    });
    const setData = (data) => {
        setGalleryData(data);
    };
    const setId = (id) => {
        setCurrentId(id);
    };
    return {
        galleryData,
        setGalleryData: setData,
        currentId,
        setCurrentId: setId,
    };
};
